import React, { ReactNode } from 'react';
import { TextColorType } from '../../shared/types/textColor.types';

const HeadingTags = {
  One: 'h1',
  Two: 'h2',
  Three: 'h3',
} as const;

type HeadingTagsType = typeof HeadingTags[keyof typeof HeadingTags];

interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  children?: string | ReactNode;
  bold?: boolean;
  heading?: HeadingTagsType;
  className?: string;
  color?: TextColorType;
  dataCy?: string;
  styleAs?: HeadingTagsType;
}

export { HeadingProps, HeadingTags, HeadingTagsType };
